import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/hightechnl.webp';
import screenshot_target from '../../../images/letterfunnel/ericmarkhuitema.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Eric-Mark Huitema"
      firstname="Eric-Mark"
      companyname="High Tech NL"
      competition="FME en Brainport Industries"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/ericmarkhuitema.js